import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { formatDate } from '../../utils/date'
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';

import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import BasicTable from '../../components/Table/BasicTable';
import Pagination from '../../components/Paging/Pagination';
import SearchInput from '../../components/Input/SearchInput';
import useInput from '../../hooks/useInput';
import { isMobile } from '../../config';
import { buyHeaderData, buyOptions } from './SupportData';

import { fetchBuyListData, fetchBuyCntData } from '../../services/buyService';

import S from './Support.module.css';

const BuyPage = () => {

  const [ buyList, setBuyList ] = useState([]);
  const [ bodyData, setBodyData ] = useState([]);
  const [ cntData, setCntData ] = useState([]);

  const [buySearch, setBuySearch] = useInput({ search: '' });
  const [ pagingInfo, setPagingInfo ] = useState([]);
  const [ curPage, setCurPage ] = useState(1);

  const [ searchParams ] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  useEffect(() => {
    const pageIdx = parseInt(searchParams.get('pageIdx')) || 1;
    setCurPage(pageIdx);
  }, [searchParams] );

  useEffect(() => {
    const fetchData = async (searchVal) => {
      try {
        const listRes = await fetchBuyListData(searchVal, curPage);
        const cntRes = await fetchBuyCntData(searchVal);

        setBuyList(listRes.buyList);
        setPagingInfo(listRes.pageInfo);
        setCntData(cntRes[0]);

      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [curPage]);

  useEffect(() => {
    const startIndex = (curPage - 1) * 10;
    const bodyListData = buyList.map((item, index) => ({
      num: { text: startIndex + index + 1, className: 'bIdxWidth' },
      title: { text: item.AC_DEPT_NAME, className: 'bTitleWidth' },
      status: { 
        text: item.AC_FLAG === 'A' ? <a href={`/support/buy/account?idx=${item.AC_IDX}`} className={S.aWidth}>결제대기</a> : item.AC_FLAG === 'Y' ? <a href="#" className={S.yWidth}>결제완료</a> : '', 
        className: 'bWidth'
      },
      date: { text: formatDate(item.AC_INPUT_DATE), className: 'bDayWidth' }
    }));
    setBodyData(bodyListData);
  }, [buyList, curPage]);

  const onPageChangeHandler = (pageNumber) => {
    navigate(`/support/buy?pageIdx=${pageNumber}`);
  };

  const handleSubmit = async (e) => {
    if (e.key === 'Enter') {
      try {
        const newListRes = await fetchBuyListData(buySearch.search, 1);
        const newCntRes = await fetchBuyCntData(buySearch.search);
  
        setBuyList(newListRes.buyList);
        setCntData(newCntRes[0]);
        setCurPage(1);
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <div>
      <HeaderComponents pageKey="support" />
      <div className='sideBannerComp'>
        <div>
          <SideBannerComponents pageKey="support" />
        </div>
        <div className='com-content-wrap'>
          <div style={{minHeight:'650px'}}>
            {isMobile() ? (
            <div className='mt-20'>
              <div className={S.searchBar}>
                <SearchInput type='text' options={buyOptions} name='search' value={buySearch.search} onChange={setBuySearch} onKeyPress={handleSubmit} selectclass={'searchSelect'} inputclass={'searchInput'}/>
              </div>
              <div className='mb-10' draggable>
                <a>Total <span className={S.cntFont}>{cntData.TOTAL_CNT}</span>건</a>
              </div>
              <BasicTable headers={buyHeaderData} items={bodyData} itemKey="buyMobileTable"/>
            </div>
            ) : (
            <div className='mt-200 mb-50'>
              <div className='mb-35' draggable>
                <a>Total <span className={S.cntFont}>{cntData.TOTAL_CNT}</span>건</a>
              </div>
              <BasicTable headers={buyHeaderData} items={bodyData} itemKey="buyTable"/>
              <div className={S.searchBar}>
                <SearchInput type='text' options={buyOptions} name='search' value={buySearch.search} onChange={setBuySearch} onKeyPress={handleSubmit} selectclass={'searchSelect'} inputclass={'searchInput'}/>
              </div>
            </div>
            )}
            <Pagination 
              currentPage={pagingInfo.curPage}
              totalPages={pagingInfo.totalPage}
              onPageChangeHandler={onPageChangeHandler}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyPage;
